import { cssTheme } from '@uds/theme-utils';
import { css } from 'linaria';

const inner = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const title = css`
  text-align: center;
`;

const reviews = css`
  ${cssTheme.breakpoints.lg} {
    padding: 0;
  }
`;

const logo = css`
  height: ${cssTheme.gu4};
  margin-bottom: ${cssTheme.gu1};
  text-align: center;
`;

const stars = css`
  height: ${cssTheme.gu3};
  margin-bottom: ${cssTheme.gu1};
  text-align: center;
  ${cssTheme.breakpoints.lg} {
    height: ${cssTheme.gu4};
  }
`;

export default () => {
  return {
    inner,
    title,
    reviews,
    logo,
    stars,
  };
};
